export default __webpack_public_path__ + "static/hero-893e3827418a1c030cfbbd1538cf30f0.jpeg";